import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'elafronApostrofos';
const args = {};

export class ElafronApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
